var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.heuteGeoeffnet)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("zur Zeit geöffnet")]):_vm._e(),(!_vm.heuteGeoeffnet)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("zur Zeit geschlossen")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }